import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const CopyComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__copy"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2832_4004)">
        <path
          d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33325 9.99998H2.66659C2.31296 9.99998 1.97382 9.8595 1.72378 9.60946C1.47373 9.35941 1.33325 9.02027 1.33325 8.66665V2.66665C1.33325 2.31302 1.47373 1.97389 1.72378 1.72384C1.97382 1.47379 2.31296 1.33331 2.66659 1.33331H8.66659C9.02021 1.33331 9.35935 1.47379 9.60939 1.72384C9.85944 1.97389 9.99992 2.31302 9.99992 2.66665V3.33331"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2832_4004">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Copy = withIcon(CopyComponent);
